import React, {useState} from 'react';

import {Button, Input} from '@/components';
import PercentageInput from '@/components/PercentageInput';
import type {AfriexBusiness} from '@/types/AfriexBusiness';

import type {PostFundingConfigPayload} from './types';

type PostFundingConfigFormProps = {
  business: AfriexBusiness;
  onSubmit: (config: PostFundingConfigPayload) => Promise<void>;
  isSubmitting: boolean;
};

const PostFundingConfigForm: React.FC<PostFundingConfigFormProps> = ({
  business,
  onSubmit,
  isSubmitting,
}) => {
  const [limitUSD, setLimitUSD] = useState(
    business?.meta?.postFundingLimitUSD?.toString() ?? '',
  );
  const [ratePercent, setRatePercent] = useState(
    business?.meta?.postFundingDailyInterestRatePercent?.toString() ?? '',
  );

  const canSubmit = limitUSD !== '' || ratePercent !== '';

  return (
    <div
      className="mb-2 py-3 px-3 bg-gray-100 dark:bg-gray-900 rounded"
      data-cy="merchant-kyb-post-funding-form"
    >
      <p className="text-slate-500 text-sm dark:text-slate-100 mb-2">
        Post-Funding Config
      </p>
      <div className="flex flex-col md:flex-row gap-3 md:items-end">
        <Input
          type="number"
          min={0}
          label="Negative-Balance Limit (USD)"
          data-cy="merchant-kyb-post-funding-limit"
          value={limitUSD}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setLimitUSD(e.target.value)
          }
        />
        <div data-cy="merchant-kyb-post-funding-rate">
          <PercentageInput
            label="Daily Interest Rate (%)"
            value={ratePercent}
            onValueChange={(rawValue) => setRatePercent(rawValue)}
          />
        </div>
        <Button
          variant="solid"
          data-cy="merchant-kyb-post-funding-save"
          disabled={isSubmitting || !canSubmit}
          onClick={() =>
            onSubmit({
              postFundingLimitUSD:
                limitUSD === '' ? undefined : Number(limitUSD),
              postFundingDailyInterestRatePercent:
                ratePercent === '' ? undefined : Number(ratePercent),
            })
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default PostFundingConfigForm;
